/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EventStatisticsSummaryData } from '../models/event-statistics-summary-data';
import { ExportEventStatisticsQuery } from '../models/export-event-statistics-query';
import { GetEventStatisticsSummaryQuery } from '../models/get-event-statistics-summary-query';
import { ListEventStatisticsForGroupQuery } from '../models/list-event-statistics-for-group-query';
import { ListEventStatisticsQuery } from '../models/list-event-statistics-query';
import { ListEventStatisticsResult } from '../models/list-event-statistics-result';

@Injectable({
  providedIn: 'root',
})
export class EventStatisticsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation eventStatisticsList
   */
  static readonly EventStatisticsListPath = '/api/EventStatistics/List';

  /**
   * Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsList$Plain$Response(params?: {
    body?: ListEventStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListEventStatisticsResult>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListEventStatisticsResult>;
      })
    );
  }

  /**
   * Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsList$Plain(params?: {
    body?: ListEventStatisticsQuery
  },
  context?: HttpContext

): Observable<ListEventStatisticsResult> {

    return this.eventStatisticsList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListEventStatisticsResult>) => r.body as ListEventStatisticsResult)
    );
  }

  /**
   * Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsList$Response(params?: {
    body?: ListEventStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListEventStatisticsResult>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListEventStatisticsResult>;
      })
    );
  }

  /**
   * Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsList(params?: {
    body?: ListEventStatisticsQuery
  },
  context?: HttpContext

): Observable<ListEventStatisticsResult> {

    return this.eventStatisticsList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListEventStatisticsResult>) => r.body as ListEventStatisticsResult)
    );
  }

  /**
   * Path part for operation eventStatisticsExport
   */
  static readonly EventStatisticsExportPath = '/api/EventStatistics/Export';

  /**
   * Esemény Statisztika exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsExport$Plain$Response(params?: {
    body?: ExportEventStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsExportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény Statisztika exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsExport$Plain(params?: {
    body?: ExportEventStatisticsQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.eventStatisticsExport$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Esemény Statisztika exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsExport()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsExport$Response(params?: {
    body?: ExportEventStatisticsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsExportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény Statisztika exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsExport$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsExport(params?: {
    body?: ExportEventStatisticsQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.eventStatisticsExport$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation eventStatisticsCsv
   */
  static readonly EventStatisticsCsvPath = '/api/EventStatistics/Csv';

  /**
   * Esemény Statisztika csv fájlba.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventStatisticsCsv$Plain$Response(params?: {
    DateFrom?: string;
    DateTo?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsCsvPath, 'get');
    if (params) {
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény Statisztika csv fájlba.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventStatisticsCsv$Plain(params?: {
    DateFrom?: string;
    DateTo?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.eventStatisticsCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Esemény Statisztika csv fájlba.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventStatisticsCsv$Response(params?: {
    DateFrom?: string;
    DateTo?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsCsvPath, 'get');
    if (params) {
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Esemény Statisztika csv fájlba.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventStatisticsCsv(params?: {
    DateFrom?: string;
    DateTo?: string;
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.eventStatisticsCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation eventStatisticsGetSummary
   */
  static readonly EventStatisticsGetSummaryPath = '/api/EventStatistics/GetSummary';

  /**
   * Szűrt sorok statisztikájának lekérdezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsGetSummary$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsGetSummary$Plain$Response(params?: {
    body?: GetEventStatisticsSummaryQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<EventStatisticsSummaryData>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsGetSummaryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EventStatisticsSummaryData>;
      })
    );
  }

  /**
   * Szűrt sorok statisztikájának lekérdezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsGetSummary$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsGetSummary$Plain(params?: {
    body?: GetEventStatisticsSummaryQuery
  },
  context?: HttpContext

): Observable<EventStatisticsSummaryData> {

    return this.eventStatisticsGetSummary$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<EventStatisticsSummaryData>) => r.body as EventStatisticsSummaryData)
    );
  }

  /**
   * Szűrt sorok statisztikájának lekérdezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsGetSummary()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsGetSummary$Response(params?: {
    body?: GetEventStatisticsSummaryQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<EventStatisticsSummaryData>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsGetSummaryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EventStatisticsSummaryData>;
      })
    );
  }

  /**
   * Szűrt sorok statisztikájának lekérdezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsGetSummary$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsGetSummary(params?: {
    body?: GetEventStatisticsSummaryQuery
  },
  context?: HttpContext

): Observable<EventStatisticsSummaryData> {

    return this.eventStatisticsGetSummary$Response(params,context).pipe(
      map((r: StrictHttpResponse<EventStatisticsSummaryData>) => r.body as EventStatisticsSummaryData)
    );
  }

  /**
   * Path part for operation eventStatisticsListEventStatisticsForGroup
   */
  static readonly EventStatisticsListEventStatisticsForGroupPath = '/api/EventStatistics/ListEventStatisticsForGroup';

  /**
   * Az adott Eseménycsoporthoz tartozó Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsListEventStatisticsForGroup$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsListEventStatisticsForGroup$Plain$Response(params?: {
    body?: ListEventStatisticsForGroupQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListEventStatisticsResult>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsListEventStatisticsForGroupPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListEventStatisticsResult>;
      })
    );
  }

  /**
   * Az adott Eseménycsoporthoz tartozó Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsListEventStatisticsForGroup$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsListEventStatisticsForGroup$Plain(params?: {
    body?: ListEventStatisticsForGroupQuery
  },
  context?: HttpContext

): Observable<ListEventStatisticsResult> {

    return this.eventStatisticsListEventStatisticsForGroup$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListEventStatisticsResult>) => r.body as ListEventStatisticsResult)
    );
  }

  /**
   * Az adott Eseménycsoporthoz tartozó Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatisticsListEventStatisticsForGroup()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsListEventStatisticsForGroup$Response(params?: {
    body?: ListEventStatisticsForGroupQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListEventStatisticsResult>> {

    const rb = new RequestBuilder(this.rootUrl, EventStatisticsService.EventStatisticsListEventStatisticsForGroupPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListEventStatisticsResult>;
      })
    );
  }

  /**
   * Az adott Eseménycsoporthoz tartozó Esemény Statisztika listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatisticsListEventStatisticsForGroup$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  eventStatisticsListEventStatisticsForGroup(params?: {
    body?: ListEventStatisticsForGroupQuery
  },
  context?: HttpContext

): Observable<ListEventStatisticsResult> {

    return this.eventStatisticsListEventStatisticsForGroup$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListEventStatisticsResult>) => r.body as ListEventStatisticsResult)
    );
  }

}
